var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "basic-information" }, [
    _c("p", { staticClass: "top-title" }, [
      _vm._v("\n    " + _vm._s(_vm.$t("company.basic.basicInfo")) + "\n  "),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "information" },
      [
        _c("InputField", {
          class:
            "" +
            (_vm.editable
              ? "small-8 medium-8 large-8"
              : "small-12 medium-12 large-12"),
          attrs: {
            readonly: !_vm.editable,
            label: _vm.$t("user.tenantName"),
            placeholder: "",
            showFlag: false,
            showColon: false,
            hideLabel: false,
            readonlyAsInput: _vm.editable,
            value: _vm.companyName,
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "project-location" },
          [
            _c(
              "label",
              {
                class: [{ "required-flag": _vm.editable }],
                attrs: { for: "projectLocation" },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("tender.general.premises")) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.editable
              ? _c("InputField", {
                  attrs: {
                    value: _vm.displayLocation,
                    placeholder: _vm.$t("tender.general.premisesHint"),
                    showFlag: false,
                    showColon: false,
                    hideLabel: false,
                    required: "",
                    readonlyAsInput: _vm.isReadonly,
                  },
                  on: {
                    updateValue: function (val) {
                      return _vm.changeInputLocation(val)
                    },
                  },
                })
              : _c("span", [_vm._v(_vm._s(_vm.displayLocation))]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "floors" },
          [
            _c(
              "label",
              {
                class: [{ "required-flag": _vm.editable }],
                attrs: { for: "floors" },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("tenancy.floors")) + "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.editable
              ? _c("HKLMultiSelect", {
                  class: { "error-highlight": !_vm.multipleFloorValidity },
                  attrs: {
                    options: _vm.floorsHklOptions,
                    value: _vm.floors,
                    showSearch: true,
                    placeholder: "",
                    disabled: _vm.isReadonly,
                  },
                  on: {
                    change: function (val) {
                      return _vm.changeInput("floors", val || [])
                    },
                  },
                })
              : _c("span", [_vm._v(_vm._s(_vm.displayFloors))]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "type" },
          [
            _c(
              "label",
              {
                class: [{ "required-flag": _vm.editable }],
                attrs: { for: "type" },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("tenancy.type")) + "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.editable
              ? _c("HKLSelect", {
                  attrs: {
                    disabled: !_vm.isDraftProject,
                    options: _vm.typeHklOptions,
                    value: _vm.type || undefined,
                    required: true,
                    showSearch: true,
                    placeholder: "",
                  },
                  on: {
                    change: function (val) {
                      return _vm.changeInput("type", val)
                    },
                  },
                })
              : _c("pre", [_vm._v(_vm._s(_vm.displayTypeStuff))]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.editable,
                    expression: "editable",
                  },
                ],
                staticClass: "project-type-radio",
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.typeSubsidiary,
                      expression: "typeSubsidiary",
                    },
                  ],
                  attrs: { type: "radio" },
                  domProps: {
                    value: _vm.typeSubsidiaryMap.businessAsUsual,
                    checked: _vm._q(
                      _vm.typeSubsidiary,
                      _vm.typeSubsidiaryMap.businessAsUsual
                    ),
                  },
                  on: {
                    change: [
                      function ($event) {
                        _vm.typeSubsidiary =
                          _vm.typeSubsidiaryMap.businessAsUsual
                      },
                      function (e) {
                        return _vm.changeInput(
                          "typeSubsidiary",
                          e.currentTarget.value
                        )
                      },
                    ],
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { attrs: { for: _vm.typeSubsidiaryMap.businessAsUsual } },
                  [
                    _vm._v(
                      _vm._s(
                        _vm._f("customValueByKey")(
                          _vm.typeSubsidiaryMap.businessAsUsual,
                          { obj: _vm.typeSubsidiaryMap, rootPath: "tenancy" }
                        )
                      )
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.typeSubsidiary,
                      expression: "typeSubsidiary",
                    },
                  ],
                  attrs: { type: "radio" },
                  domProps: {
                    value: _vm.typeSubsidiaryMap.temporarySuspension,
                    checked: _vm._q(
                      _vm.typeSubsidiary,
                      _vm.typeSubsidiaryMap.temporarySuspension
                    ),
                  },
                  on: {
                    change: [
                      function ($event) {
                        _vm.typeSubsidiary =
                          _vm.typeSubsidiaryMap.temporarySuspension
                      },
                      function (e) {
                        return _vm.changeInput(
                          "typeSubsidiary",
                          e.currentTarget.value
                        )
                      },
                    ],
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { attrs: { for: _vm.typeSubsidiaryMap.temporarySuspension } },
                  [
                    _vm._v(
                      _vm._s(
                        _vm._f("customValueByKey")(
                          _vm.typeSubsidiaryMap.temporarySuspension,
                          { obj: _vm.typeSubsidiaryMap, rootPath: "tenancy" }
                        )
                      )
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _vm.editable
              ? _c("InputField", {
                  staticClass: "small-10 medium-10 large-10",
                  attrs: {
                    label: "",
                    placeholder: "",
                    showColon: false,
                    hideLabel: true,
                    value: _vm.typeRemarks,
                  },
                  on: {
                    updateValue: function (val) {
                      return _vm.changeInput("typeRemarks", val)
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c("InputField", {
          staticClass: "small-10 medium-10 large-10 project-description",
          attrs: {
            readonly: !_vm.editable,
            label: _vm.$t("tender.general.projectDescription"),
            placeholder: "",
            showColon: false,
            hideLabel: false,
            showFlag: _vm.editable,
            value: _vm.displayDescription,
            required: "",
          },
          on: {
            updateValue: function (val) {
              return _vm.changeInput("description", val)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tentative-date" },
          [
            _c(
              "label",
              {
                class: [{ "required-flag": _vm.editable }],
                attrs: { for: "tentative-date" },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("tenancy.tentativeDateofWorkCommencement")) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.editable
              ? _c("DatePicker", {
                  attrs: {
                    calendarButton: true,
                    value: _vm.tentativeDate,
                    calendarButtonIcon: "fa fa-calendar",
                    clearButton: true,
                    disabled: {
                      to: new Date(Date.now() - _vm.dateUtil.ONE_DAY_MILLI),
                    },
                    required: "",
                  },
                  on: {
                    selected: function (val) {
                      return _vm.changeInput("tentativeDate", val)
                    },
                  },
                })
              : _c("span", [_vm._v(_vm._s(_vm.displayTentativeDate))]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "estimatedDuration" },
          [
            _c("InputField", {
              staticClass: "small-4 medium-4 large-4",
              attrs: {
                readonly: !_vm.editable,
                label: _vm.$t("tender.general.estimatedDuration"),
                placeholder: "",
                showColon: false,
                showFlag: _vm.editable,
                value: _vm.editable
                  ? _vm.estimatedDuration
                  : (_vm.estimatedDuration || "--") +
                    " " +
                    _vm.$t("tender.general.days"),
                pattern: _vm.regex.integer,
                required: "",
              },
              on: {
                updateValue: function (val) {
                  return _vm.changeEstimatedDuration(val)
                },
              },
            }),
            _vm._v(" "),
            _vm.editable
              ? _c("span", { staticClass: "days" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("tender.general.days")) +
                      "\n      "
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _vm.estimatedDuration
          ? _c("div", { staticClass: "tentative-end-date" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("tenancy.tentativeEndDate", [_vm.tentativeEndDate])
                  ) +
                  "\n    "
              ),
            ])
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }